import React, {FC} from 'react';

import {useUserTheme} from '../../../../libs/shared/ui/src/theme/userThemeProvider';
import {TeamModel} from '../../../models/api/teamModel';
import {Avatar, AvatarProps} from './avatar';
import {AvatarBackground} from './avatarBackground';
import {AvatarInitials} from './avatarInitials';

/*
 * Props.
 */

interface TeamAvatarProps extends AvatarProps {
  /** The {@link ITeam} to display. */
  team: TeamModel;
}

/*
 * Component.
 */

/** Display the avatar of the specified {@link ITeam}. */
export const TeamAvatar: FC<TeamAvatarProps> = (props) => {
  const {team, size} = props;
  const {name, color} = team;
  const initial = name[0] || '';
  const theme = useUserTheme();
  return (
    <Avatar {...props}>
      <AvatarBackground color={theme.palette[color].shade20} />
      <AvatarInitials size={size} textColor={theme.palette[color].shade40} value={initial} isBold />
    </Avatar>
  );
};
